export const backArrowSvg = (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Back Arrow</title>
    <path
      d="M5.54479 12.077L6.46623 11.2323L2.42062 6.81894H11.9999V5.56894H2.50874L6.88374 1.19394L5.99985 0.310059L0.134766 6.17515L5.54479 12.077Z"
      className="fill-ock-foreground"
    />
  </svg>
);
